<template>
    <div class="aipage">
        <div class="banner-img background" :style="{ 'backgroundImage' : `url(${require('@/assets/images/bussiness/maas/bannerWrap.png')})`}">
            <div class="banner">
                <div class="banner-title background" :style="{ 'backgroundImage' : `url(${content.bannerTitle})`}"></div>
                <div class="banner-smallTitle">{{ content.bannerSmallTitle }}</div>
                <div style="margin-top: 0.2rem;">
                  <div class="banner-btn" v-if="content.bannerBtnList">
                      <div class="banner-btn-item" v-for="item in content.bannerBtnList" :key="item.index" :class="{'banner-btn-item-active': item.value == nowTitle}" @click="changeContent(item)">
                        {{ item.label }}
                      </div>
                  </div>
                </div>
            </div>
        </div>
        <div class="aipage_wrap background" :style="{ 'backgroundImage' : `url(${require('@/assets/images/bussiness/maas/maas_bg1.png')})`}">
            <div class="aipage_content" style="width: 11.4rem;">
                <p class="titleBlue" >应用场景</p>
                <div class="flex-between">
                    <div class="content-item background" v-for="item in content.aiContentList" :key="item.index" :style="{ 'backgroundImage' : `url(${item.wrapPic})`}" >
                        <span class="content-item-label">{{ item.title }}</span>
                        <span class="content-item-content">{{ item.content }}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="aipage_wrap background" :style="{ 'backgroundImage' : `url(${require('@/assets/images/bussiness/maas/maas_bg2.png')})`, height:'4.3rem' }">
            <div class="aipage_content">
                <p class="titleBlue" style="color: #fff;">产品概述</p>
                <div class="flex-between">
                    <div class="background productdes" :style="{ 'backgroundImage' : `url(${content.productOverviewImg})`}" ></div>
                    <div class="productlabel">
                        <div>{{ content.productOverviewTitle }}</div>
                        <div style="margin-top:0.24rem">{{ content.productOverviewContent }}</div>
                    </div>
                </div>             
            </div>
        </div>
        <div class="aipage_wrap background" :style="{ 'backgroundImage' : `url(${require('@/assets/images/bussiness/maas/maas_bg3.png')})`}">
            <div class="aipage_content" style="width: 11.4rem;">
                <p class="titleBlue" >产品优势</p>
                <div class="flex-between">
                    <div class="productGoods-item " :style="{ width: 9 / content.productGoodsList.length + 'rem' }" v-for="item in content.productGoodsList" :key="item.index">
                        <div class="productGoods-item-icon background" :style="{ 'backgroundImage' : `url(${item.wrapPic})`}"></div>
                        <div class="productGoods-item-title">{{ item.title }}</div>
                        <div class="productGoods-item-content">{{ item.content }}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="aipage_wrap background" :style="{ 'backgroundImage' : `url(${require('@/assets/images/bussiness/maas/maas_bg4.png')})`}">
            <div class="aipage_content" >
                <p class="titleBlue" style="color: #fff;">产品架构</p>
                <div class="arch-item background" v-if="content.productArchitectureImg" :style="{ 'backgroundImage' : `url(${content.productArchitectureImg})`}"></div>
                <div class="arch-item2 background" :style="{ 'backgroundImage' : `url(${content.productArchitectureImg2})`}"></div>
            </div>
        </div>

        <div class="aipage_wrap background" :style="{ 'backgroundImage' : `url(${require('@/assets/images/bussiness/maas/maas_bg5.png')})`}" v-if="content.productCapacityList">
            <div class="aipage_content">
                <p class="titleBlue">产品能力</p>
                <div class="flex-wrap background" :style="{ 'backgroundImage' : `url(${content.productCapacityImg})`, 'justify-content': 'space-around', 'height' : '3.1rem'}">
                    <div class="productCapacity-item background" v-for="item in content.productCapacityList" :key="item.index"  :style="{ right: { 4:'0rem', 6:'0rem', 8:'0.15rem' }[content.productCapacityList.length], width: { 4:'5rem', 6:'3.2rem', 8:'2.3rem' }[content.productCapacityList.length] }">
                        <div class="productCapacity-item-title">{{ item.title }}</div>
                        <div class="productCapacity-item-content">{{ item.content }}</div>
                    </div>
                </div>
            </div>
        </div>

        <div class="aipage_wrap background" :style="{ 'backgroundImage' : `url(${require('@/assets/images/bussiness/maas/maas_bg6.png')})`}" v-if="content.caseList">
            <div class="aipage_content" >
                <p class="titleBlue" style="color: #fff;">产品案例</p>
                <div class="flex-center">
                    <div class="case-item" v-for="item in content.caseList" :key="item.index">
                        <div class="case-item-img background" :style="{ 'backgroundImage' : `url(${item.wrapPic})`}"></div>
                        <div class="case-item-label">
                            <div style="height: 0.35rem; line-height: 0.35rem;">{{  item.title }}</div>
                            <div class="case-item-content" v-if="item.content">{{  item.content }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div> 
    </div>
</template>


<script>
/* eslint-disable */
export default {
    props: {
        content: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            nowTitle: this.content.bannerBtnList[0].value
        }
    },
    mounted() {
        // 页面加载时回到顶部
        document.body.scrollTop = document.documentElement.scrollTop = 0;
        
        // 初始化检测可见元素
        this.checkVisibility();
        
        // 监听滚动事件（使用节流优化性能）
        this.scrollHandler = this.throttle(() => {
            this.checkVisibility();
        }, 100); // 100ms触发一次，平衡性能与灵敏度
        window.addEventListener('scroll', this.scrollHandler);
    },

    beforeDestroy() {
        // 移除滚动监听，避免内存泄漏
        window.removeEventListener('scroll', this.scrollHandler);
    },

    methods: {
        // 节流函数：限制事件触发频率
        throttle(fn, delay) {
            let lastTime = 0;
            return function(...args) {
                const now = Date.now();
                if (now - lastTime > delay) {
                lastTime = now;
                fn.apply(this, args);
                }
            };
        },

        // 检测元素是否进入视图范围
        isElementInViewport(el) {
            const rect = el.getBoundingClientRect();
            // 元素顶部进入视图底部80%位置时判定为可见（优化触发时机）
            return rect.top <= (window.innerHeight || document.documentElement.clientHeight) * 0.8;
        },

        // 检查所有动画元素的可见性
        checkVisibility() {
            const animatedElements = document.querySelectorAll(
                '.content-item, .serviceWrap, .operation-item, .advantage-item, .case-item'
            );
            
            animatedElements.forEach(el => {
                if (this.isElementInViewport(el) && !el.classList.contains('visible')) {
                    el.classList.add('visible');
                }
            });
        },
        changeContent(item){
          this.nowTitle = item.value
          this.$emit('change',item.value)
        }
    }
}
</script>


<style lang="scss" scoped>
// 入场动画关键帧定义
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.banner {
  left: 20%;
  top: 1.4rem;
  animation: fadeIn 0.8s ease-out forwards; /*  banner区域入场动画 */
  opacity: 0;
  &-title {
    width: 4.7rem;
    height: 1.4rem;
    background-size: contain;
  }
  &-smallTitle {
    color: #fff;
    width: 8rem;
    letter-spacing: 2px;
    line-height: 0.24rem;
    font-size: 0.14rem;
    animation-delay: 0.3s; /* 标题文字延迟出现 */
    opacity: 0;
    animation: fadeInUp 0.8s ease-out forwards;
  }
}

.background {
  background-position: center;
  background-repeat: no-repeat;
}

.banner-img {
  width: 100%;
  height: 2.8rem;
  position: relative;
  background-size: cover;
}

.titleBlue {
  font-size: 0.3rem;
  color: #0061e3;
  font-weight: 600;
  letter-spacing: 0.05rem;
  text-align: center;
  height: 0.6rem;
  margin: 0.2rem 0;
  font-family: '黑体';
  opacity: 0;
  animation: fadeInUp 0.6s ease-out forwards;
  animation-delay: 0.2s;
}

// 为各区块内容添加入场动画（通过滚动触发，配合visibility控制）
.content-item {
  width: 2.6rem;
  height: 3rem;
  margin-bottom:0.4rem;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  cursor: pointer;
  position: relative;
  opacity: 0;
  border-radius: 0.06rem;
  animation: fadeInUp 0.6s ease-out forwards;
  visibility: hidden; /* 初始隐藏 */
  &:nth-child(1) { animation-delay: 0.1s; }
  &:nth-child(2) { animation-delay: 0.2s; }
  &:nth-child(3) { animation-delay: 0.3s; }
  &:nth-child(4) { animation-delay: 0.4s; }
}
.content-item.visible { visibility: visible; } /* 滚动到视图时显示 */

.content-item-titleBg {
  width: 0.8rem;
  height: 0.68rem;
  color: #0061e3;
  font-size: 0.17rem;
  font-weight: 600;
  text-align: center;
  background-size: contain;
  position: relative;
}

.content-item-title {
  position: absolute;
  bottom: -0.05rem;
  left: 0.28rem;
}

.content-item-label {
  font-size: 0.16rem;
  color: #f2f3f4;
  font-weight: 600;
  position: absolute;
  top: 1.67rem;
  width: 2.6rem;
  text-align: center;
}

.content-item-content{
    font-size: 0.14rem;
    color: #333;
    position: absolute;
    top:2.16rem;
    width: 2.2rem;
    margin-left: 0.26rem;
}

.productGoods-item{
    width: 1.8rem;
    height: 3rem;
    border-radius: 0.04rem;
    padding:0 0.16rem;
    background: #fff;
    border-radius: 4px;
}

.productGoods-item-title{
    font-size: 0.16rem;
    font-weight: 600;
    color: #333;
    position: relative;
    text-align: center;
    margin-bottom: 0.2rem;
}
.productGoods-item-icon{
  width: 1rem;
  height: 1rem;
  position: relative;
  margin:0.3rem auto;
}
.productGoods-item-content{
    font-size: 0.13rem;
    color: #4C4C4C;
    position: relative;
    text-align: left;
}

.arch-item{
   width: 12rem;
   height: 0.5rem;
   background-size: contain;
}

.arch-item2{
   width: 12rem;
   height: 3.5rem;
   background-size: contain;
   margin-top: 0.12rem;
}

.productCapacity-item{
   width: 2.4rem;
   height: 1rem;
   background: #fff;
   box-shadow: 0px 0px 6px 0px rgba(0,6,64,0.1);
   border-radius: 0.04rem;
   padding:0.12rem;
   position: relative;
   top:0.15rem;
}

.productCapacity-item-title{
    font-weight: 600;
    color: #333;
    position: relative;
    top:0.05rem;
}

.productCapacity-item-content{
    color: #333;
    font-size: 0.13rem;
    position: relative;
    top:0.18rem;
}

.case-item {
  cursor: pointer;
  overflow: hidden;
  opacity: 0;
  animation: fadeInUp 0.6s ease-out forwards;
  visibility: hidden;
  margin:0 0.2rem;
  &:nth-child(1) { animation-delay: 0.1s; }
  &:nth-child(2) { animation-delay: 0.2s; }
}
.case-item.visible { visibility: visible; }

.case-item-img {
  width: 5.4rem;
  height: 3rem;
  transition: all 0.3s ease;
}

.case-item-label {
  width: 100%;
  background: #fff;
  padding: 0.12rem 0;
  font-size: 0.2rem;
  color: #333;
  font-weight: 600;
  text-indent: 0.2rem;
  border-bottom-right-radius: 0.04rem;
  border-bottom-left-radius: 0.04rem;
  transition: all 0.3s ease;
  margin-bottom:0.5rem;
}
.case-item-content{
   font-size: 0.14rem;
   font-weight: 500;
   color: #333;
   width: 4rem;
   text-indent: 0;
   margin-left: 0.2rem;
   margin-top: 0.06rem;
   height: 0.4rem;
}

// 悬停动画效果
.content-item:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 20px rgba(0, 97, 227, 0.1);
}

.serviceWrap:hover {
  transform: scale(1.02);
  filter: brightness(1.1);
}

.operation-item:hover {
  transform: scale(1.03);
  box-shadow: 0 8px 16px rgba(0, 97, 227, 0.15);
}

.case-item:hover .case-item-img {
  transform: scale(1.05);
}

.case-item:hover .case-item-label {
  background-color: #0061e3;
  color: #fff;
}
.case-item:hover .case-item-content {
  color: #fff;
}
@media screen and (min-width: 2000px) {
    .banner {
      &-smallTitle {
        font-size: 0.12rem;
      }
      &-title {
        width: 4.2rem;
        height: 1.2rem;
      }
    }
    
    .titleBlue {
      font-size: 0.26rem;
    }
    .content-item-titleBg {
      width: 0.72rem;
      height: 0.6rem;
      font-size: 0.15rem;
    }

    .content-item-label {
      font-size: 0.14rem;
    }
    .service-item-title {
      font-size: 0.15rem;
    }

    .service-item-text {
      font-size: 0.14rem;
    }
    .operation-item-label {
      font-size: 0.18rem;
    }

    .operation-item-content {
      font-size: 0.14rem;
    }
    .advantage-item-title {
      font-size: 0.15rem;
    }
    .advantage-item-content {
      font-size: 0.12rem;
    }
    .case-item-label {
      font-size: 0.16rem;
    }
    .productlabel{
        font-size: 0.13rem;
        letter-spacing: 0.01rem;
    }
    .banner-btn-item{
      font-size: 0.14rem;
    }
    .productGoods-item-title{
        font-size: 0.14rem;
    }
    .productGoods-item-content{
        font-size: 0.12rem;
    }
}
 
</style>

<style lang="scss">
.aipage {
  .el-button--small {
    padding: 0.1rem 0.4rem;
    border-color: #0061e3;
    color: #0061e3;
    font-weight: 600;
    border-radius: 0;
    transition: all 0.3s ease;
  }
  .el-button--small:hover {
    background-color: #0061e3;
    color: #fff;
    transform: translateY(-2px);
  }
}

.aipage_wrap {
  width: calc(100% - 0.48rem);
  display: flex;
  justify-content: center;
  padding: 0.24rem;
  background-color: #f5f5f5;
}

.aipage_content {
  width: 12rem;
}

.flex-center {
  display: flex;
  justify-content: center;
}

.flex-wrap {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.flex-between {
  display: flex;
  justify-content: space-between;
}

.dot-w {
  display: inline-block;
  width: 0.08rem;
  height: 0.08rem;
  background-color: #fff;
  border-radius: 50%;
}

.el-divider--horizontal {
  margin: 0.16rem 0;
}
.productdes{
   width: 7rem;
   height: 3.1rem;
   background-size: contain;
}
.productlabel{
    font-size: 0.14rem;
    color: #f8f8f8;
    letter-spacing: 0.02rem;
    width: 4.8rem;
    position: relative;
    top:0.5rem;
}
.banner-btn{ 
  width: 3.2rem; 
  padding: 0.02rem;
  background: #4C4C4C;
  text-align: center;
  border-radius: 0.04rem;
  display: flex;
  justify-content: space-between;
}
.banner-btn-item{
    display: inline-block;
    font-size: 0.16rem;
    border-radius: 0.04rem;
    padding:0.04rem 0.2rem;
    font-weight: 600;
    color: #A8A8A8;
    cursor: pointer;
}
.banner-btn-item-active{
    color: #fff;
    background: #0463D8;
}
</style>